export default "__VITE_ASSET__DlgmUKcR__"